var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var LoadedData = /** @class */ (function () {
    function LoadedData() {
        this.sportIds = [];
        this.tags = [];
        this.dates = {};
    }
    LoadedData.prototype.setSportIds = function (sportIds) {
        this.sportIds = __spread(this.sportIds, sportIds);
    };
    LoadedData.prototype.setDates = function (sportIds, date) {
        var _this = this;
        sportIds.forEach(function (sportId) {
            !_this.dates[sportId] && (_this.dates[sportId] = []);
            _this.dates[sportId].push(date);
        });
    };
    LoadedData.prototype.setTags = function (tag) {
        this.tags.push(tag);
    };
    /**
     * Clear all loaded data
     */
    LoadedData.prototype.clearData = function () {
        this.sportIds = [];
        this.tags = [];
        this.dates = {};
    };
    /**
     * Check if current sport ids were already loaded
     * @param {string[]} sportIds current ids
     * @returns {boolean}
     */
    LoadedData.prototype.containsSportIds = function (sportIds) {
        var _this = this;
        return sportIds.every(function (id) { return _this.sportIds.indexOf(id) !== -1; });
    };
    /**
     * Check if current date was already loaded
     * @param {number} date current date
     * @returns {boolean}
     */
    LoadedData.prototype.containsDate = function (sportId, date) {
        return this.dates[sportId] && this.dates[sportId].indexOf(date) !== -1;
    };
    /**
     * Check if current date & sport ids were already loaded
     * @param {string[]} sportIds current ids
     * @param {number} date current date
     * @returns {boolean}
     */
    LoadedData.prototype.containsSportIdsAndDate = function (sportIds, date) {
        var _this = this;
        return sportIds.every(function (sportId) { return _this.containsDate(sportId, date.getDate()); });
    };
    /**
     * Check if current tag was already loaded
     * @param {EventsBySportIdRequest.EventTagsEnum} tag current tag
     * @returns {boolean}
     */
    LoadedData.prototype.containsTag = function (tag) {
        return this.tags.indexOf(tag) !== -1;
    };
    /**
     * If there is sport, which was not loaded until now add it
     * and return true, else - false
     * @param {string[]} sportIds- current sport ids
     * @returns {boolean}
     */
    LoadedData.prototype.updateSports = function (sportIds) {
        if (!this.containsSportIds(sportIds)) {
            this.setSportIds(sportIds);
            return true;
        }
        return false;
    };
    /**
     * If there is date, which was not loaded until now add it
     * and return true, else - false
     * @param {Date} date- current date
     * @returns {boolean}
     */
    LoadedData.prototype.updateDates = function (sportIds, date) {
        if (!this.containsSportIdsAndDate(sportIds, date)) {
            this.setDates(sportIds, date.getDate());
            return true;
        }
        return false;
    };
    /**
     * If there is tag, which was not loaded until now add it
     * and return true, else - false
     * @param {EventsBySportIdRequest.EventTagsEnum} tag - current tag
     * @returns {boolean}
     */
    LoadedData.prototype.updateTags = function (tag) {
        if (!this.containsTag(tag)) {
            this.setTags(tag);
            return true;
        }
        return false;
    };
    return LoadedData;
}());
export { LoadedData };
//# sourceMappingURL=LoadedData.js.map